import { type PropsWithChildren, createContext, useMemo } from 'react';

export interface LocalFiltersContextValue {
  where: any;
  setWhere: (where: any) => void;
}

export const LocalFiltersContext =
  createContext<LocalFiltersContextValue | null>(null);

export const LocalFiltersProvider: React.FC<
  PropsWithChildren<{ where: any; setWhere: (where: any) => void }>
> = ({ children, where, setWhere }) => {
  const contextValue = useMemo(() => ({ where, setWhere }), [where, setWhere]);

  return (
    <LocalFiltersContext.Provider value={contextValue}>
      {children}
    </LocalFiltersContext.Provider>
  );
};
